module.exports = __webpack_public_path__ + "static/accumulus-advisory-logo-dark-ff2c97f66ec53b01c965ef953dba8b12.svg";